/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class ViewToggle extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'ViewToggle');

    this.el = $(el);
    this.init(this.el);
  }

  setup(elm) {
    elm.find('.btn-toggle').each(function () {
      const target = $(this).attr('data-toggle-target');

      if (!$(this).hasClass('active')) {
        $(target).addClass('hidden');
      }
    })
  }

  init(elm) {
    this.setup(elm);

    elm.on('click', '.btn-toggle', function () {
      if (!$(this).hasClass('active')) {
        const target = $(this).attr('data-toggle-target');
        $(this).addClass('active');
        $(this).siblings('.btn-toggle').each(function () {
          $(this).removeClass('active');
          $($(this).attr('data-toggle-target')).addClass('hidden');
        })

        $(target).removeClass('hidden');
      }
    })
  }
}
